import { render } from "./AppFooter.vue?vue&type=template&id=59e859fa&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=59e859fa&lang=css"
import "./AppFooter.vue?vue&type=style&index=1&id=59e859fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e859fa"]])

export default __exports__